import { useContext, useEffect, useState } from 'react';
import { BrandingContext } from 'pages/_app';
import { BRANDING, IS_XSOLA } from 'util/constants';

export const useLocalStorageBranding = () => {
  const [localBranding, setLocalBranding] = useState<string | null>(null);

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        const storedBranding = localStorage.getItem('NEXT_PUBLIC_BRANDING');
        if (storedBranding) {
          setLocalBranding(storedBranding);
        }
      } catch (error) {
        console.warn('Failed to read branding from localStorage:', error);
      }
    }
  }, []);

  const setBranding = (branding: string) => {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        localStorage.setItem('NEXT_PUBLIC_BRANDING', branding);
        setLocalBranding(branding);
      } catch (error) {
        console.warn('Failed to set branding in localStorage:', error);
      }
    }
  };

  const clearBranding = () => {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
      try {
        localStorage.removeItem('NEXT_PUBLIC_BRANDING');
        setLocalBranding(null);
      } catch (error) {
        console.warn('Failed to clear branding from localStorage:', error);
      }
    }
  };

  return {
    localBranding,
    setBranding,
    clearBranding,
    branding: localBranding || BRANDING,
  };
};

export const useBranding = () => {
  const branding = useContext(BrandingContext);

  return {
    branding,
    isZepeto: branding === 'ZEPETO',
    isXsolla: branding === 'XSOLLA',
    isUnity: branding === 'UNITY',
    isDefault: branding === 'DEFAULT' || !branding,
    isXsollaOrZepeto: branding === 'XSOLLA' || branding === 'ZEPETO',
  };
};

export const useBrandingFeatures = () => {
  const { branding } = useBranding();

  return {
    showZepetoAssets: branding === 'ZEPETO',
    showXsollaAssets: branding === 'XSOLLA',
    showPolicyLinks: branding === 'ZEPETO' || branding === 'XSOLLA',
    showUnityExport: branding === 'UNITY',
    showZepetoExport: branding === 'ZEPETO',
    showXsollaExport: branding === 'XSOLLA',
  };
};
